import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { LeadProvider } from "@/context/LeadContext";
import SmoothScroll from "@/components/SmoothScroll";
import Layout from "@/components/Layout";

import Home from "@/pages/Home";
import Services from "@/pages/Services";
import ServiceDetail from "@/pages/ServiceDetail";
import LeakDetection from "@/pages/LeakDetection";
import CostEstimator from "@/pages/CostEstimator";
import Gallery from "@/pages/Gallery";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Admin from "@/pages/Admin";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <LeadProvider>
          <SmoothScroll>
            <Routes>
              <Route element={<Layout />}>
                <Route path="/" element={<Home />} />
                <Route path="/services" element={<Services />} />
                <Route path="/services/:slug" element={<ServiceDetail />} />
                <Route path="/leak-detection" element={<LeakDetection />} />
                <Route path="/cost-estimator" element={<CostEstimator />} />
                <Route path="/gallery" element={<Gallery />} />
                <Route path="/about" element={<About />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/blog" element={<Blog />} />
                <Route path="/blog/:slug" element={<BlogPost />} />
              </Route>
              <Route path="/admin" element={<Admin />} />
            </Routes>
          </SmoothScroll>
          <Toaster position="top-center" richColors />
        </LeadProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
